module.exports = __webpack_public_path__ + "files/496b37e45fd141be657453e8f65ccc8b.png";